import React from "react";
import { Text } from "@chakra-ui/react";
export function Pill(props) {
    return (React.createElement(Text, { as: "span", fontSize: "sm", fontWeight: "medium", bg: "gray.200", color: "text.secondary", borderRadius: "full", px: 2, py: 0.5, ...props }));
}
